export default {
  "Submitting": "_Submitting_17v8n_1"
};import "ni:sha-256;18jYKGu4V5epYbWCLrxG9uOszn-HjUgZRm7krAS2IbU";